module.exports = __webpack_public_path__ + "601378df83cba23c2a23f04d3d391a9b.jpg";